"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _formik = require("formik");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _DayPicker = _interopRequireWildcard(require("../../DayPicker"));

var _FormikValidation = _interopRequireDefault(require("../FormikValidation"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FormikDayPicker = function FormikDayPicker(_ref) {
  var name = _ref.name,
      range = _ref.range,
      disableClickOutside = _ref.disableClickOutside,
      formik = _ref.formik,
      onChange = _ref.onChange,
      validation = _ref.validation,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "range", "disableClickOutside", "formik", "onChange", "validation"]);

  var setFieldTouched = formik.setFieldTouched,
      setFieldValue = formik.setFieldValue,
      values = formik.values;
  var value = (0, _lodash.default)(values, name, range ? {
    from: undefined,
    to: undefined
  } : undefined);

  var onSelectedDate = function onSelectedDate(dates) {
    setFieldTouched(name);

    if (range) {
      setFieldValue(name, dates);
    } else {
      setFieldValue(name, dates.from);
    }

    if (onChange) {
      onChange({
        dateValue: dates.from
      });
    }
  };

  var Component = disableClickOutside ? _DayPicker.Unwrapped : _DayPicker.default;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Component, _extends({}, props, {
    name: name,
    onSelectedDate: onSelectedDate,
    range: range ? value : {
      from: value
    },
    style: disableClickOutside ? {
      position: 'static'
    } : undefined,
    closeButton: !!disableClickOutside,
    GA: {},
    dateRange: range
  })), validation && _react.default.createElement(_FormikValidation.default, {
    name: name
  }));
};

FormikDayPicker.defaultProps = {
  disableClickOutside: false,
  range: false,
  onChange: undefined,
  validation: true
};
FormikDayPicker.propTypes = {
  name: _propTypes.string.isRequired,
  disableClickOutside: _propTypes.bool,
  range: _propTypes.bool,
  onChange: _propTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  formik: _propTypes.any.isRequired,
  validation: _propTypes.bool
};

var _default = (0, _formik.connect)(FormikDayPicker);

exports.default = _default;